import React from 'react';
import BannerSlider from '../../../assets/containers/bannerSlider';

const mediaItems = [
    {
        "_id": "679a148e7dc1a98a9e4c07af",
        "title": "test",
        "titleVisible": false,
        "description": "",
        "position": "Bottom",
        "type": "Video",
        "srcList": [
            {
                "src": "https://api.v2.rahebehesht.com/file/get/poster_motion_1739254775.mp4",
                "videoCover": "/images/hubble/testSlider.png",
                "type": "Video",
                "_id": "679a14e37dc1a98a9e4c07cd"
            },
            {
                "src": "/images/hubble/testSlider.png",
                "type": "Image",
                "_id": "679a14e37dc1a98a9e4c07ce"
            }
        ],
        "index": 1,
        "link": "",
        "linkNewTab": false,
        "highlight": false,
        "timer": null,
        "timerLabel": "",
        "rowCount": null,
        "createdAt": "2025-01-29T11:44:14.317Z",
        "updatedAt": "2025-01-29T11:45:39.980Z",
        "__v": 0,
        "src": "https://api.v2.rahebehesht.com/file/get/poster_motion_1739254775.mp4",
        "videoCover": "https://api.v2.rahebehesht.com/file/get/poster_motion_1739255053.PNG"
    },
    {
        "_id": "679a148e7dc1a98a9e4c07af",
        "title": "test",
        "titleVisible": false,
        "description": "",
        "position": "Bottom",
        "type": "Video",
        "srcList": [
            {
                "src": "https://api.v2.rahebehesht.com/file/get/Habel_Teaser_1739441654.mp4",
                "videoCover": "/images/hubble/testSlider.png",
                "type": "Video",
                "_id": "679a14e37dc1a98a9e4c07cd"
            },
            {
                "src": "/images/hubble/testSlider.png",
                "type": "Image",
                "_id": "679a14e37dc1a98a9e4c07ce"
            }
        ],
        "index": 1,
        "link": "",
        "linkNewTab": false,
        "highlight": false,
        "timer": null,
        "timerLabel": "",
        "rowCount": null,
        "createdAt": "2025-01-29T11:44:14.317Z",
        "updatedAt": "2025-01-29T11:45:39.980Z",
        "__v": 0,
        "src": "https://api.v2.rahebehesht.com/file/get/Habel_Teaser_1739441654.mp4",
        "videoCover": "https://api.v2.rahebehesht.com/file/get/Habel_Teaser_1739441435.jpg"
    },
    {
        "_id": "679a148e7dc1a98a9e4c07af",
        "title": "test",
        "titleVisible": false,
        "description": "",
        "position": "Bottom",
        "type": "Video",
        "srcList": [
            {
                "src": "https://api.v2.rahebehesht.com/file/get/Teaser3_1739549138.mp4",
                "videoCover": "/images/hubble/testSlider.png",
                "type": "Video",
                "_id": "679a14e37dc1a98a9e4c07cd"
            },
            {
                "src": "/images/hubble/testSlider.png",
                "type": "Image",
                "_id": "679a14e37dc1a98a9e4c07ce"
            }
        ],
        "index": 1,
        "link": "",
        "linkNewTab": false,
        "highlight": false,
        "timer": null,
        "timerLabel": "",
        "rowCount": null,
        "createdAt": "2025-01-29T11:44:14.317Z",
        "updatedAt": "2025-01-29T11:45:39.980Z",
        "__v": 0,
        "src": "https://api.v2.rahebehesht.com/file/get/Teaser3_1739549138.mp4",
        "videoCover": "https://api.v2.rahebehesht.com/file/get/video_2025-02-14_19-33-05_1739549098.jpg"
    },
    // {
    //     "_id": "679a148e7dc1a98a9e4c07af",
    //     "title": "test",
    //     "titleVisible": false,
    //     "description": "",
    //     "position": "Bottom",
    //     "type": "Image",
    //     "srcList": [
    //         {
    //             "src": "http://127.0.0.1:2546/file/get/Podcast_2_1734606408.mp4",
    //             "videoCover": "/images/hubble/testSlider.png",
    //             "type": "Video",
    //             "_id": "679a14e37dc1a98a9e4c07cd"
    //         },
    //         {
    //             "src": "/images/hubble/testSlider.png",
    //             "type": "Image",
    //             "_id": "679a14e37dc1a98a9e4c07ce"
    //         }
    //     ],
    //     "index": 1,
    //     "link": "",
    //     "linkNewTab": false,
    //     "highlight": false,
    //     "timer": null,
    //     "timerLabel": "",
    //     "rowCount": null,
    //     "createdAt": "2025-01-29T11:44:14.317Z",
    //     "updatedAt": "2025-01-29T11:45:39.980Z",
    //     "__v": 0,
    //     "src": "/images/hubble/testSlider.png"
    // }
]


const HubbleMediaSlider = () => {
    return (
        <div className='w-100 mb-5 hubbleSlider'>
            <BannerSlider banners={mediaItems} />
        </div>
    )
}

export default HubbleMediaSlider